const messagePopup = document.querySelector( '#wcbt-snackbar' );
let popupTimeout;

const displayMessagePopup = () => {
	messagePopup.classList.add( 'active' );
	if ( popupTimeout ) {
		clearTimeout( popupTimeout );
	}

	popupTimeout = setTimeout( () => {
		messagePopup.classList.remove( 'active' );
		messagePopup.innerHTML = '';
	}, '3000' );
};

export { messagePopup, displayMessagePopup };
